import React, { FC } from "react"

const ROTATION = { right: 0, down: 90, left: 180, up: 270 }

/**
 * The chevron of kahuna-base-react-components (assets/chevron-right.svg), drawn inline so it never
 * depends on a file being served next to the page, turned to whichever way it points.
 */
const Chevron: FC<{ direction: keyof typeof ROTATION; size?: number }> = ({ direction, size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ transform: `rotate(${ROTATION[direction]}deg)`, flexShrink: 0 }}
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.19282 5.80762L8.30894 6.6915L11.617 9.99956L8.30894 13.3076L9.19282 14.1915L13.3848 9.99956L9.19282 5.80762Z"
      fill="#111111"
    />
  </svg>
)

export default Chevron
